import React, { FC } from 'react';
import type { OfferingOutline } from './ClientOutlineTypes';
import DocumentOfferingManagement from './DocumentOfferingManagement';
import OfferingHours from './OfferingHours';
import RelatedWork from './RelatedWork';

interface OfferingTabProps {
    clientId: string;
    sowId: string;
    offering: OfferingOutline;
}

const OfferingTab: FC<OfferingTabProps> = ( { clientId, sowId, offering } ) => {
    return (
        <div>
            <div style={ { marginTop: 16 } }>
                <div className={ 'consultant-offering-work-grid' }>
                    <div className={ 'consultant-offering-work-grid-main' }>
                        <DocumentOfferingManagement
                            clientId={ clientId }
                            sowId={ sowId }
                            clientOfferingId={ offering.ClientOfferingId }
                        />
                    </div>

                    <div className={ 'consultant-offering-work-grid-side' }>
                        <RelatedWork
                            clientId={ clientId }
                            offeringId={ offering.OfferingId }
                        />
                    </div>

                    {/* <div className={ 'consultant-offering-work-grid-bottom' }>
                        <OfferingHours
                            clientId={ clientId }
                            sowId={ sowId }
                            offeringId={ offering.OfferingId }
                            clientOfferingId={ offering.ClientOfferingId }
                            offeringName={ offering.OfferingName }
                        />
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default OfferingTab;
